<template>
  <div v-if="liveData">
    <div v-if="showPlaying">
      <!-- 竖屏直播 -->
      <LivePlayingVertical
        v-if="liveData.live_info.screen_type === 2"
        :liveData="liveData"
        :liveStatus="liveStatus"
      />
      <!-- 横屏直播 -->
      <LivePlaying v-else :liveData="liveData" :liveStatus="liveStatus" />
    </div>
    <div v-else>
      <LiveBooking :liveData="liveData" @onDownTimeEnd="isBookingDownTimeEnd = true" />
    </div>
  </div>
</template>

<script>
import { getLiveDetailApi } from '@/api/live/live'
import LiveBooking from './liveModules/LiveBooking.vue'
import LivePlaying from './liveModules/LivePlaying.vue'
import LivePlayingVertical from './liveModules/LivePlayingVertical.vue'

export default {
  data() {
    return {
      liveData: null, //直播数据
      isBookingDownTimeEnd: false, //直播预约时间是否结束
    }
  },
  mixins: [],
  components: { LiveBooking, LivePlaying, LivePlayingVertical },

  computed: {
    // 直播状态 0未开始 1直播中 2直播结束 3可回放
    liveStatus() {
      return this.liveData?.live_info?.live_status || 0
    },
    // 是否购买
    isBuy() {
      return this.liveData.has_qualify || false
    },
    // 是否可以免费观看（可分享）
    isFreePlay() {
      return this.liveData.is_share || false
    },
    // 是否显示播放中
    showPlaying() {
      return this.liveData?.live_info?.live_status !== 0 || !!this.isBookingDownTimeEnd
    },
  },
  created() {
    this.getLiveDetail()
  },
  methods: {
    async getLiveDetail() {
      const params = this.routeFixedParam()

      params.id = this.$route.query.id

      params.course_no = this.$route.query.course_no
      params.fileid = ''
      const respose = await getLiveDetailApi(params).catch((err) => {
        this.$toast('接口请求异常')
      })
      const resposeData = respose?.data || null
      this.liveData = resposeData
      // 可回放
      if (this.liveStatus === 3) {
        if (resposeData.replay_list[0].reply_url) {
          this.$util.windowLocationHref(resposeData.replay_list[0].reply_url)
        }
      }
      // if(respose){}

      // console.log(resposeData);

      this.setShareCard()
      document.getElementsByTagName('title')[0].innerText = this.liveData.nostart.centralCourseName
    },

    // 设置分享卡片
    setShareCard() {
      const shareOpiton = this.liveData.shareInfo || {}
      this.$util.setShare({
        title: shareOpiton.title || '',
        desc: shareOpiton.desc || '',
        link: window.location.href,
        imgUrl: shareOpiton.image || '',
      })
    },
  },
}
</script>

<style></style>
